import {useContext} from 'react';
import AlertContext from '../../../store/alert-context';

import styles from './Alert.module.css';

const Alert = props => {

	const alertCtx = useContext(AlertContext);

	const typeStyles = alertCtx.type==='success' ? styles.Success : '';
	let animationStyles = '';
	if (alertCtx.isShown) animationStyles = styles.SlideIn; 
	if (alertCtx.isClosed) animationStyles = styles.SlideOut; 

	return (
		<div className={`${styles.Alert} ${typeStyles} ${animationStyles}`}>
			<i className='bi bi-check-circle me-2'></i>
			<p className='mb-0 lead'>{alertCtx.message}</p>
		</div>
	)
}

export default Alert;